if (!customElements.get('famiware-deferred-section')) {
  class FamiwareDeferredSection extends HTMLElement {
    connectedCallback() {
      if (this.observer || this.loading) return;
      if (!('IntersectionObserver' in window)) {
        this.load();
        return;
      }
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          this.observer.disconnect();
          this.load();
        }
      }, { rootMargin: '500px 0px' });
      this.observer.observe(this);
    }
    async load() {
      if (this.loading) return;
      this.loading = true;
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', this.dataset.sectionId);
      try {
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Section request failed');
        const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        const section = documentFragment.getElementById(`shopify-section-${this.dataset.sectionId}`);
        if (!section || section.querySelector('famiware-deferred-section')) throw new Error('Section unavailable');
        section.querySelectorAll('noscript').forEach((fallback) => fallback.remove());
        this.replaceChildren(...Array.from(section.childNodes));
        this.style.minHeight = '';
        this.className = 'block';
        this.setAttribute('aria-busy', 'false');
        requestAnimationFrame(() => window.initLazyImages());
      } catch (error) {
        this.querySelector('.famiware-section-placeholder')?.remove();
        this.style.minHeight = '';
        this.setAttribute('aria-busy', 'false');
        this.loading = false;
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }
  customElements.define('famiware-deferred-section', FamiwareDeferredSection);
}

